import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import TableRow, { TData } from "./TableRow";
// import { steps } from '../Sidebar'
import { fluidType, device, priceFormatted } from "../../../utils/helpers";

const Wrapper = styled.div`
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
`;

const Thead = styled.th`
  background-color: #999999;
  color: #fff;
  text-transform: uppercase;
  font-family: "BarlowSemiBold";
  font-size: 14px;
  padding: 18px;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  white-space: nowrap;
  text-align: right;

  ${"" /* ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '14px',
      '21px'
    )
}; */} &:first-child {
    font-family: "BarlowExtraBold";
    border: none;
    text-align: left;
    font-size: 16px;
    ${"" /* ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '16px',
      '24px'
    )
}; */};
  }

  &:last-child {
    font-family: "BarlowExtraBold";
    border: none;
    font-size: 16px;
    ${"" /* ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '16px',
      '24px'
    )
}; */};
  }

  @media ${device.tablet} {
    ${"" /* padding: 25px; */} padding: 1.3020833333333335vw;
    font-size: 1.09375vw;

    &:first-child {
      font-size: 1.25vw;
    }

    &:last-child {
      font-size: 1.25vw;
    }
  }
`;

class CalculatorTable extends Component {
  render() {
    const { steps, net, tax, total, coefficient } = this.props;
    return (
      <Wrapper>
        <Table>
          <thead>
            <tr>
              {/* <Thead>{`${steps[0].name} ${steps[0].selectedComponent}`}</Thead> */}
              <Thead>{`${steps[0].selectedComponent}`}</Thead>
              <Thead>Netto</Thead>
              <Thead>IVA 22%</Thead>
              <Thead>Lordo</Thead>
            </tr>
          </thead>
          <tbody>
            {steps.map((item, index) => {
              if (index !== 0) {
                return <TableRow item={item} key={index} />;
              }
            })}
            <tr>
              <TData />
              <TData />
              <TData />
              <TData />
            </tr>
            <tr>
              <TData style={{ color: "#fca317" }}>Totale</TData>
              <TData style={{ color: "#999999" }}>{priceFormatted(net)}</TData>
              <TData style={{ color: "#999999" }}>{priceFormatted(tax)}</TData>
              <TData style={{ color: "#fca317" }}>
                {priceFormatted(total)}
              </TData>
              {/* <TData style={{ color: '#999999' }}>{priceFormatted(net + (net * coefficient))}</TData>
              <TData style={{ color: '#999999' }}>{priceFormatted(tax + (tax * coefficient))}</TData>
              <TData style={{ color: '#fca317' }}>{priceFormatted(total + (total * coefficient))}</TData> */}
            </tr>
          </tbody>
        </Table>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    steps: state.calculator.steps,
    total: state.calculator.total,
    net: state.calculator.net,
    tax: state.calculator.tax,
    coefficient: state.calculator.coefficient
  };
}

export default connect(mapStateToProps)(CalculatorTable);



// WEBPACK FOOTER //
// ./src/components/Calculator/Table/index.js